var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.25C6.34614 22.25 1.75 17.6539 1.75 12C1.75 6.34614 6.34614 1.75 12 1.75C17.6539 1.75 22.25 6.34614 22.25 12C22.25 17.6539 17.6539 22.25 12 22.25ZM12 2.25C6.62386 2.25 2.25 6.62386 2.25 12C2.25 17.3761 6.62386 21.75 12 21.75C17.3761 21.75 21.75 17.3761 21.75 12C21.75 6.62386 17.3761 2.25 12 2.25Z",
    fill: "#292D32",
    stroke: "#0E1B28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C11.8661 13.25 11.75 13.1339 11.75 13V8C11.75 7.86614 11.8661 7.75 12 7.75C12.1339 7.75 12.25 7.86614 12.25 8V13C12.25 13.1339 12.1339 13.25 12 13.25Z",
    fill: "#292D32",
    stroke: "#0E1B28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5467 16.2004L11.5469 16.2003L11.5415 16.1876C11.5128 16.1187 11.5 16.054 11.5 15.9999C11.5 15.9457 11.5128 15.881 11.5415 15.8122C11.566 15.7535 11.5996 15.6977 11.6444 15.6443C11.6978 15.5995 11.7536 15.5659 11.8123 15.5414C11.9292 15.4927 12.0708 15.4927 12.1877 15.5414C12.2464 15.5659 12.3022 15.5995 12.3556 15.6443C12.4004 15.6977 12.434 15.7535 12.4585 15.8122C12.4872 15.881 12.5 15.9457 12.5 15.9999C12.5 16.054 12.4872 16.1187 12.4585 16.1876L12.4583 16.1875L12.4533 16.2004C12.4336 16.2516 12.4069 16.2961 12.3565 16.3548C12.3028 16.3999 12.2467 16.4337 12.1877 16.4583C12.1188 16.487 12.0541 16.4999 12 16.4999C11.9459 16.4999 11.8812 16.487 11.8123 16.4583C11.7533 16.4337 11.6972 16.3999 11.6435 16.3548C11.5931 16.2961 11.5664 16.2516 11.5467 16.2004Z",
    fill: "#292D32",
    stroke: "#0E1B28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.57e2a28b.svg";
export { ForwardRef as ReactComponent };